import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.service'
import { Observable, Subscription } from 'rxjs'
import { Router } from '@angular/router'
import { SessionService } from '../../services/session.service'
import { map } from 'rxjs/operators'
import { UserGroup } from '../../shared/types/user-group.types'
import { GetAccountQuery, GetLocationQuery } from 'src/app/API.service'
import { OfficeFilterService } from '../../services/office-filter.service'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  accounts: Array<GetAccountQuery>
  locations: Array<GetLocationQuery>

  private accountsSub: Subscription
  private locationsSub: Subscription
  private selectAccountSub: Subscription
  private selectLocationSub: Subscription

  selectedLocationId: any
  selectedAccountId: any

  constructor(
    private sessionService: SessionService,
    private authService: AuthService,
    private router: Router,
    private officeFilterService: OfficeFilterService
  ) {
    this.accounts = null
    this.locations = null
  }

  ngOnInit(): void {
    // Make sure to watch the accounts list and reload
    this.accountsSub = this.officeFilterService.accountSelection$.subscribe(
      accounts => {
        this.accounts = accounts
      }
    )
    // Make sure to watch the locations list and reload
    this.locationsSub = this.officeFilterService.locationSelection$.subscribe(
      locations => {
        this.locations = locations
      }
    )

    // Should there be a selected account, keep watch of the id
    // So that it will be selected in the UI
    this.selectAccountSub = this.officeFilterService.selectedAccount$.subscribe(
      account => {
        this.selectedAccountId = account?.id
      }
    )

    // Should there be a selected location, keep watch of the id
    // So that it will be selected in the UI
    this.selectLocationSub = this.officeFilterService.selectedLocation$.subscribe(
      location => {
        this.selectedLocationId = location?.id
      }
    )
  }

  onAccountSelection(value) {
    // The value here is an account ID
    // because of how we used the dropdown
    // so we need to select the correct object
    // and set that to the service
    this.officeFilterService.selectAccount(
      this.accounts.find(l => {
        return l.id === value
      })
    )
  }

  onLocationSelection(value) {
    // The value here is an location ID
    // because of how we used the dropdown
    // so we need to select the correct object
    // and set that to the service
    this.officeFilterService.selectLocation(
      this.locations.find(l => {
        return l.id === value
      })
    )
  }

  accessGroups$(): Observable<Array<UserGroup>> {
    return this.sessionService.accessGroups$.asObservable()
  }

  username$(): Observable<string> {
    return this.sessionService.email$
      .asObservable()
      .pipe(
        map(email => (email ? email.substring(0, email.indexOf('@')) : email))
      )
  }

  pageName$(): Observable<string> {
    return this.sessionService.currentPageName$
  }

  userType$(): Observable<string> {
    return this.sessionService.userType$.asObservable()
  }

  loggedIn$(): Observable<boolean> {
    return this.sessionService.loggedIn$.asObservable()
  }

  logout(): void {
    this.authService.logout().then(() => {
      return this.router.navigate(['/login'])
    })
  }

  async goToDashboard(): Promise<void> {
    await this.router.navigate(['/'])
  }

  ngOnDestroy(): void {
    this.accountsSub.unsubscribe()
    this.locationsSub.unsubscribe()
    this.selectAccountSub.unsubscribe()
    this.selectLocationSub.unsubscribe()
  }
}
